'use client';

import { Clock, Truck, Package, CurrencyCircleDollar } from '@phosphor-icons/react';

const CONDITIONS = [
  {
    icon: Clock,
    title: 'Часы работы',
    description: 'Принимаем заказы ежедневно с 11:00 до 22:00',
    gradient: 'linear-gradient(to bottom right, #7B42FF, #5B28D1)',
  },
  {
    icon: CurrencyCircleDollar,
    title: 'Стоимость доставки',
    description: 'Стоимость доставки зависит от выбранной зоны',
    gradient: 'linear-gradient(to bottom right, #8B5CF6, #7B42FF)',
  },
  {
    icon: Package,
    title: 'Минимальный заказ',
    description: 'Сумма минимального заказа зависит от зоны доставки',
    gradient: 'linear-gradient(to bottom right, #7C3AED, #A78BFA)',
  },
  {
    icon: Truck,
    title: 'Время доставки',
    description: 'Среднее время доставки 60–120 минут с момента подтверждения',
    gradient: 'linear-gradient(to bottom right, #5B28D1, #7B42FF)',
  },
];

export function DeliveryConditions() {
  return (
    <section className="py-16 sm:py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-[var(--bg-secondary)]" />
      <div className="blur-blob absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[var(--primary)]/8 blur-[120px]" />
      <div className="blur-blob absolute bottom-0 -right-20 w-[350px] h-[350px] rounded-full bg-[var(--violet-400)]/6 blur-[90px]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-12 sm:mb-16 animate-fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[var(--primary-subtle)] text-[var(--primary)] text-sm font-semibold mb-4">
            <Truck weight="fill" className="w-4 h-4" />
            Условия
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-black tracking-tight text-[var(--text-primary)] mb-4">
            Условия{' '}
            <span className="text-[var(--primary)]">доставки</span>
          </h2>
          <p className="text-[var(--text-secondary)] text-lg max-w-2xl mx-auto">
            Всё, что нужно знать о нашей доставке
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CONDITIONS.map((item, i) => (
            <div
              key={item.title}
              className="group relative animate-fade-up"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="relative rounded-2xl bg-[var(--surface-primary)] border border-[var(--border-default)] p-6 h-full transition-all duration-300 hover:shadow-xl hover:shadow-[var(--primary)]/5 hover:-translate-y-1 hover:border-[var(--border-hover)]">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 shadow-lg shadow-[var(--primary)]/15 transition-transform duration-300 group-hover:scale-110"
                  style={{ background: item.gradient }}
                >
                  <item.icon weight="fill" className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-bold text-[var(--text-primary)] mb-2">{item.title}</h3>
                <p className="text-sm text-[var(--text-secondary)] leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
